import { JSX } from 'react'

import { IconProps } from '../../icon'

const Slide: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.7692 8H10.2308C9.55795 8 9 8.55795 9 9.23077C9 9.90359 9.55795 10.4615 10.2308 10.4615H10.641V27.2821C10.641 28.8574 11.9374 30.1538 13.5128 30.1538H23.7692V34.5518C22.801 35.0113 22.1282 35.9959 22.1282 37.1282C22.1282 38.7036 23.4246 40 25 40C26.5754 40 27.8718 38.7036 27.8718 37.1282C27.8718 35.9795 27.199 35.0113 26.2308 34.5518V30.1538H36.4872C38.0626 30.1538 39.359 28.8574 39.359 27.2821V10.4615H39.7692C40.4421 10.4615 41 9.90359 41 9.23077C41 8.55795 40.4421 8 39.7692 8ZM24.5897 37.1282C24.5897 36.8985 24.7703 36.7179 25 36.7179C25.2297 36.7179 25.4103 36.8985 25.4103 37.1282C25.4103 37.5877 24.5897 37.5877 24.5897 37.1282ZM36.8974 27.2821C36.8974 27.5118 36.7169 27.6923 36.4872 27.6923H13.5128C13.2831 27.6923 13.1026 27.5118 13.1026 27.2821V10.4615H36.8974V27.2821Z'
      fill='black'
    />
  </svg>
)

export default Slide
